<!-- <mat-drawer-container class="example-container" autosize> -->
<!-- Notificación de actualización de versión -->
<app-version-update-notification
  [isVisible]="showVersionUpdate"
  [newVersion]="newVersion"
  [currentVersion]="currentVersion"
  (update)="handleVersionUpdate()"
  (dismiss)="dismissVersionUpdate()"
></app-version-update-notification>

<app-header *ngIf="showHead"></app-header>
<mat-sidenav-container class="side-nav-container" [class.side-nav-container--full]="!showHead">
  <mat-sidenav
    style="width: 270px; padding: 20px 0px"
    #sidenavlogin
    mode="over"
    [fixedInViewport]="false"
    position="end"
    role="navigation"
  >
    <div class="container-nav justify-content-between">
      <div class="nav-btns">
        <div class="close-btn">
          <i
            (click)="sidenavlogin.close()"
            class="fa-solid fa-chevron-right"
          ></i>
        </div>
        <button
          class="user-btn user-info"
          *ngIf="credentialsService.isAuthenticated()"
        >
          <i class="fa-solid fa-user"></i>
          <div class="d-flex flex-column">
            <span> {{ credentialsService.credentials?.first_name }}</span>
            <span class="mail">
              {{ credentialsService.credentials?.email }}</span
            >
          </div>
        </button>
        <a
          *ngIf="credentialsService.hasAnyAuthority(['ROLE_AGENT', 'ROLE_ADMIN'])"
          style="text-align: start"
          class="items"
          (click)="
            navigateToUrl('tablero-de-usuario/asesor-ia'); closeSideNavs()
          "
        >
          <span>{{ "components.menuDashboard.aiAdvisor" | translate }}</span>
        </a>
        <a
          id="btn-buy-mobile"
          style="text-align: start"
          class="items"
          (click)="
            navigateToUrl('tablero-de-usuario/mi-cuenta'); closeSideNavs()
          "
          routerLinkActive="active"
        >
          <span>{{ "components.header.account" | translate }}</span>
        </a>
        <a
          (click)="
            navigateToUrl('tablero-de-usuario/mi-cartera'); closeSideNavs()
          "
          style="text-align: start"
          id="btn-sell-mobile"
          class="items"
          routerLinkActive="active"
        >
          <span>{{ "components.header.properties" | translate }}</span>
        </a>
        <a
          class="items"
          style="text-align: start"
          (click)="navigateToUrl('tablero-de-usuario'); closeSideNavs()"
        >
          <span>{{ "components.header.favorites" | translate }}</span>
        </a>
        <a
          class="items"
          style="text-align: start"
          (click)="
            navigateToUrl('tablero-de-usuario/mis-busquedas'); closeSideNavs()
          "
        >
          <span>{{ "components.header.searches" | translate }}</span>
        </a>
      </div>
      <div class="bottom-btns">
        <button class="user-btn logout" (click)="logout(); closeSideNavs()">
          {{ "components.header.logout" | translate }}
          <i class="fa-solid fa-arrow-right-from-bracket"></i>
        </button>
      </div>
    </div>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-sidenav-container class="side-nav-container" [class.side-nav-container--full]="!showHead">
      <mat-sidenav
        style="width: 270px; padding: 20px 0px"
        #sidenav
        mode="over"
        [fixedInViewport]="false"
        position="end"
        role="navigation"
      >
        <div class="container-nav justify-content-between">
          <div class="nav-btns">
            <div class="close-btn">
              <i (click)="sidenav.toggle()" class="fa-regular fa-x"></i>
            </div>
            <a
              id="btn-buy-mobile"
              style="text-align: start"
              class="items"
              (click)="goNavigateToUrl('invertir'); drawer.toggle()"
              routerLinkActive="active"
            >
              <span>{{ "components.header.invest" | translate }}</span>
            </a>
            <a
              [routerLink]="['/' + translateService.currentLang + '/vende']"
              (click)="goNavigateToUrl('vende'); drawer.toggle()"
              style="text-align: start"
              id="btn-sell-mobile"
              class="items"
              routerLinkActive="active"
            >
              <span>{{ "components.header.sell" | translate }}</span>
            </a>
            <a
              class="items"
              style="text-align: start"
              [routerLink]="[
                '/' + translateService.currentLang + '/como-funciona'
              ]"
              (click)="goNavigateToUrl('como-funciona'); drawer.toggle()"
            >
              <span>{{ "components.header.howDoesItWork" | translate }}</span>
            </a>
            <a
              class="items"
              style="text-align: start"
              (click)="navigateToUrl('sobre-nosotros')"
            >
              <span>{{ "components.header.aboutInviertis" | translate }}</span>
            </a>
            <a
              *ngIf="!credentialsService.isAuthenticated()"
              class="items"
              style="text-align: start"
              (click)="openLoginModal()"
            >
              <span>{{ "components.header.enter" | translate }}</span>
            </a>
          </div>
          <div class="bottom-btns">
            <button
              class="call-me-now btns"
              id="btn-callmeback-header"
              (click)="openCallModal(); sidenav.toggle()"
              *ngIf="!credentialsService.isAuthenticated()"
            >
              <img
                class="icon-btn"
                src="{{ picturesServer }}img/home/icono-telefono.svg"
                alt="Ícono teléfono"
                loading="lazy"
              />
              {{ "components.footer.Te llamamos" | translate }}
            </button>
            <button
              id="btn-register"
              class="btns create"
              (click)="openSignInModal()"
              routerLinkActive="active"
              *ngIf="!credentialsService.isAuthenticated()"
            >
              <i class="fa-solid fa-user"></i>
              <span>{{ "components.header.createAccount" | translate }}</span>
            </button>
            <button
              class="user-btn"
              *ngIf="credentialsService.isAuthenticated()"
              (click)="sidenavlogin.toggle()"
            >
              <i class="fa-solid fa-user"></i>
              <span>
                {{ credentialsService.credentials?.first_name }}
              </span>
              <i class="fa-solid fa-chevron-down"></i>
            </button>
          </div>
        </div>
      </mat-sidenav>
      <mat-sidenav-content id="sidenav-content-global">
        <ul class="w-100 my-0 cabecera" *ngIf="!flagAreaPrivada">
          <li *ngFor="let migaja of breadcrumbs">
            <div *ngIf="language == 'es'" class="breadcrumbs_container">
              <a
                *ngIf="migaja.path != null"
                (click)="goToRoute(migaja)"
                class="migaja"
                >{{ "migaja.label" | translate }}</a
              >
              <p *ngIf="migaja.path == null" class="last_migaja">
                {{ "migaja.label" | translate }}
              </p>
            </div>
            <div *ngIf="language == 'en'" class="breadcrumbs_container">
              <a
                *ngIf="migaja.path != null"
                (click)="goToRoute(migaja)"
                class="migaja"
                >{{ "migaja.label_en" | translate }}</a
              >
              <p *ngIf="migaja.path == null" class="last_migaja">
                {{ "migaja.label_en" | translate }}
              </p>
            </div>
          </li>
        </ul>
        <router-outlet (activate)="scrollService.toTop($event)"></router-outlet>
        <app-footer *ngIf="showHead"></app-footer>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </mat-sidenav-content>
</mat-sidenav-container>

<mat-drawer #drawer class="drawer-sidenav-container" mode="side">
  <div class="close-btn btn-drawer">
    <i (click)="drawer.close()" class="fa-solid fa-arrow-left"></i>
    <i (click)="drawer.close(); sidenav.toggle()" class="fa-solid fa-x"></i>
  </div>

  <app-nav-tooltip-invest
    *ngIf="showSliderInvest"
    (cardSelected)="onCardSelected($event); drawer.close(); sidenav.toggle()"
    (closeTooltip)="drawer.close(); sidenav.toggle()"
  >
  </app-nav-tooltip-invest>

  <app-nav-tooltip-sell
    *ngIf="showSliderSell"
    (closeTooltip)="drawer.close(); sidenav.toggle()"
  >
  </app-nav-tooltip-sell>

  <app-nav-tooltip-how-it-works
    *ngIf="showSliderHowItWorks"
    (closeTooltip)="drawer.close(); sidenav.toggle()"
  >
  </app-nav-tooltip-how-it-works>
</mat-drawer>
<!-- </mat-drawer-container> -->
